import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'

Vue.use(VueLocalStorage)

export default {
  namespaced: true,

  state: () => ({
    toolbar: `top`,
    contrast: `normal`,
    showingSettings: false,
  }),

  getters: {
    theme: () => Vue.localStorage.get(`theme`),
    isShowing: ({ showingSettings }) => showingSettings,
    toolbarIsTop: ({ toolbar }) => toolbar === `top`,
    contrastIsHigh: ({ contrast }) => contrast === `high`,
  },

  actions: {
    setToolbar: ({ commit }) => {
      commit(`updateToolbar`, Vue.localStorage.get(`toolbar`, `top`))
    },

    setContrast: ({ commit }) => {
      commit(`updateContrast`, Vue.localStorage.get(`contrast`, `normal`))
    },

    changeToolbar({ commit }, { target }) {
      clearTimeout()
      setTimeout(() => {
        commit(`updateToolbar`, target.value)
      }, 300)
    },

    changeContrast({ commit }, { target }) {
      commit(`updateContrast`, target.value)
    },

    toggle({ commit, getters: { isShowing } }) {
      isShowing = isShowing === false
      commit(`setIsShowing`, isShowing)
      return isShowing
    },
  },

  mutations: {
    updateToolbar(state, direction) {
      state.toolbar = direction
      Vue.localStorage.set(`toolbar`, state.toolbar)
    },

    updateContrast(state, contrastMode) {
      state.contrast = contrastMode
      Vue.localStorage.set(`contrast`, state.contrast)
    },

    updateTheme(state, theme) {
      state.theme = theme
      Vue.localStorage.remove(`theme`)
      Vue.localStorage.set(`theme`, state.theme)
    },

    setIsShowing(state, isShowing) {
      state.showingSettings = isShowing
    },
  },
}
